import React, { useEffect, useState, useMemo } from 'react';
import AuthUser from './AuthUser';
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';

// Table-based salary styles
const salaryTableStyles = `
    .salary-table {
        font-size: 0.85rem;
        border-collapse: collapse;
    }
    .salary-table thead th {
        font-size: 0.78rem;
        padding: 8px 10px;
        white-space: nowrap;
        background: #f1f3f5;
        border: 1px solid #dee2e6;
        text-align: center;
        font-weight: 700;
    }
    .salary-table thead th.formula-col {
        color: #0d6efd;
    }
    .salary-table tbody td {
        padding: 6px 10px;
        vertical-align: middle;
        border: 1px solid #dee2e6;
    }
    .salary-table .section-row td {
        background: #e2e6ea;
        font-weight: 700;
        font-size: 0.82rem;
        padding: 6px 10px;
        border: 1px solid #dee2e6;
    }
    .salary-table .section-row-deduction td {
        background: #dc3545;
        color: #fff;
        font-weight: 700;
        font-size: 0.82rem;
        padding: 6px 10px;
        border: 1px solid #dee2e6;
    }
    .salary-table .employer-row td {
        background: #f8e8ff;
    }
    .salary-table .gross-row td {
        font-weight: 700;
        background: #fff8e1;
    }
    .salary-table .total-salary-row td {
        font-weight: 700;
        font-size: 0.9rem;
        background: #e8f5e9;
        border-top: 2px solid #388e3c;
    }
    .salary-table .perday-row td {
        background: #e3f2fd;
    }
    .salary-table .deduction-row td {
        background: #fff9c4;
    }
    .salary-table .total-deduction-row td {
        background: #ffe082;
        font-weight: 600;
    }
    .salary-table .net-salary-row td {
        background: #00897b;
        color: #fff;
        font-weight: 700;
        font-size: 0.95rem;
        border-top: 2px solid #00695c;
    }
    .salary-table .formula-input {
        font-family: 'Courier New', monospace;
        font-size: 0.8rem;
        color: #0d6efd;
        border: 1px dashed #90caf9;
        padding: 4px 8px;
        border-radius: 4px;
        width: 100%;
        background: #f8f9ff;
        text-align: center;
    }
    .salary-table .formula-input:focus {
        border-color: #0d6efd;
        outline: none;
        background: #fff;
        box-shadow: 0 0 0 2px rgba(13,110,253,0.15);
    }
    .salary-table .value-cell {
        text-align: right;
        font-weight: 600;
        font-family: 'Courier New', monospace;
        min-width: 110px;
    }
    .salary-table .value-input {
        text-align: right;
        font-weight: 700;
        font-family: 'Courier New', monospace;
        font-size: 0.85rem;
        border: 1px solid #ced4da;
        padding: 4px 8px;
        border-radius: 4px;
        width: 100%;
    }
    .salary-table .value-input:focus {
        border-color: #198754;
        outline: none;
        box-shadow: 0 0 0 2px rgba(25,135,84,0.15);
    }
    .salary-table .method-badge {
        font-size: 0.7rem;
        padding: 2px 8px;
        border-radius: 10px;
    }
    .salary-table .var-badge {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 4px;
        font-weight: 700;
        font-size: 0.8rem;
        color: #fff;
        background: #6c757d;
    }
    .salary-table .pct-input-group {
        display: flex;
        align-items: center;
        gap: 4px;
        justify-content: center;
    }
    .salary-table .pct-input {
        font-family: 'Courier New', monospace;
        font-size: 0.8rem;
        color: #0d6efd;
        border: 1px dashed #90caf9;
        padding: 4px 6px;
        border-radius: 4px;
        width: 60px;
        text-align: center;
        background: #f8f9ff;
    }
    .salary-table .pct-input:focus {
        border-color: #0d6efd;
        outline: none;
        background: #fff;
    }
    .salary-table .formula-text {
        font-family: 'Courier New', monospace;
        font-size: 0.8rem;
        color: #0d6efd;
    }
`;

//salary master add
export default function SalaryMasterAdd() {
    const { http, user } = AuthUser();
    const navigate = useNavigate();
    const { id } = useParams();
    const isEditMode = !!id;
    
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [empTypeOptions, setEmpTypeOptions] = useState([]);
    const [templateList, setTemplateList] = useState([]);
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [showEmployeeModal, setShowEmployeeModal] = useState(false);
    const [empModalLoading, setEmpModalLoading] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [noDepartments, setNoDepartments] = useState(true);
    const [newEmployee, setNewEmployee] = useState({
        name: '', last_name: '', email: '', password: '',
        department_id: '', phone_number: '', designation_name: ''
    });
    const [formData, setFormData] = useState({
        user_id: '',
        father_name: '',
        address: '',
        dob: '',
        date_of_join: '',
        designation: '',
        qualification: '',
        experience: '',
        location: '',
        bank_ifsc: '',
        account_num: '',
        pf_acc_num: '',
        esi_number: '',
        pf_enabled: false,
        pf_percent: '',
        pf_formula: '',
        pf_epf_formula: '',
        esi_enabled: false,
        esi_percent: '',
        esi_formula: '',
        esi_formula_2: '',
        esi_employee_formula: '',
        esi_employee_formula_2: '',
        pt_enabled: false,
        pt_percent: '',
        pt_formula: '',
        total_pf: '',
        total_pf_epf: '',
        total_esi: '',
        total_esi_2: '',
        total_esi_employee: '',
        total_esi_employee_2: '',
        total_pt: '',
        total_salary: '',
        total_salary_formula: '',
        pf_employee_formula: '',
        pf_employee_formula_2: '',
        total_pf_employee: '',
        total_pf_employee_2: '',
        tds_deduction_formula: '',
        total_tds_deduction: '',
        total_deduction: '',
        net_salary: '',
        emp_type: '',
        grade: '',
        basic_salary: '',
        gross_salary: '',
        per_day_salary: '',
        old_salary: '',
        da_per: '',
        hra_per: '',
        tds_per: '',
        formula: 'A+B+C-D',
        working_days: '30',
        per_day_base: 'E'
    });

    // Evaluate formula with variable map
    const evaluateWithVars = (formula, vars) => {
        if (!formula || formula.trim() === '') return 0;
        try {
            let expr = formula;
            const keys = Object.keys(vars).sort((a, b) => b.length - a.length);
            keys.forEach(key => {
                expr = expr.replace(new RegExp('\\b' + key + '\\b', 'g'), vars[key].toString());
            });
            if (!/^[\d\s+\-*/().]+$/.test(expr)) return 0;
            const result = new Function('return ' + expr)();
            return isNaN(result) || !isFinite(result) ? 0 : parseFloat(result.toFixed(2));
        } catch (error) {
            return 0;
        }
    };

    // Calculate all salary components
    // Part 1: A-E (Gross), Part 2: F-K (Employer), I (Total Salary), J (Per Day)
    // Part 3: Deductions (10-15), Total Deduction, NET SALARY
    const calculateAll = (data) => {
        const A = parseFloat(data.basic_salary) || 0;
        const B = (A * (parseFloat(data.da_per) || 0)) / 100;
        const C = (A * (parseFloat(data.hra_per) || 0)) / 100;
        const D = (A * (parseFloat(data.tds_per) || 0)) / 100;

        // E = Gross Salary
        const E = evaluateWithVars(data.formula || 'A+B+C-D', { A, B, C, D });

        // F = PF EPS (Employer)
        const F = data.pf_formula ? evaluateWithVars(data.pf_formula, { A, B, C, D, E }) : 0;

        // G = PF EPF (Employer)
        const G = data.pf_epf_formula ? evaluateWithVars(data.pf_epf_formula, { A, B, C, D, E, F }) : 0;

        // H = ESI Employer
        const H = data.esi_formula ? evaluateWithVars(data.esi_formula, { A, B, C, D, E, F, G }) : 0;

        // K = ESI Employer-2
        const K = data.esi_formula_2 ? evaluateWithVars(data.esi_formula_2, { A, B, C, D, E, F, G, H }) : 0;

        // I = Total Salary via editable formula
        const salaryVars = { A, B, C, D, E, F, G, H, K };
        const I = data.total_salary_formula ? evaluateWithVars(data.total_salary_formula, salaryVars) : 0;

        // J = Per Day Salary = base / working_days (base is E or I)
        const days = parseFloat(data.working_days) || 30;
        const perDayBase = data.per_day_base === 'I' ? I : E;
        const J = perDayBase > 0 ? (perDayBase / days) : 0;

        // Deductions - can reference A through K, I, J
        const allVars = { A, B, C, D, E, F, G, H, K, I, J };
        const dedPf = data.pf_employee_formula ? evaluateWithVars(data.pf_employee_formula, allVars) : 0;
        const dedPf2 = data.pf_employee_formula_2 ? evaluateWithVars(data.pf_employee_formula_2, allVars) : 0;
        const dedEsi = data.esi_employee_formula ? evaluateWithVars(data.esi_employee_formula, allVars) : 0;
        const dedEsi2 = data.esi_employee_formula_2 ? evaluateWithVars(data.esi_employee_formula_2, allVars) : 0;
        const dedPt = data.pt_formula ? evaluateWithVars(data.pt_formula, allVars) : 0;
        const dedTds = data.tds_deduction_formula ? evaluateWithVars(data.tds_deduction_formula, allVars) : 0;

        const totalDeduction = dedPf + dedPf2 + dedEsi + dedEsi2 + dedPt + dedTds;
        const netSalary = I - totalDeduction;

        return {
            da_amount: B,
            hra_amount: C,
            tds_amount: D,
            gross_salary: E.toFixed(2),
            total_pf: F.toFixed(2),
            total_pf_epf: G.toFixed(2),
            total_esi: H.toFixed(2),
            total_esi_2: K.toFixed(2),
            total_salary: I.toFixed(2),
            per_day_salary: J.toFixed(2),
            total_pf_employee: dedPf.toFixed(2),
            total_pf_employee_2: dedPf2.toFixed(2),
            total_esi_employee: dedEsi.toFixed(2),
            total_esi_employee_2: dedEsi2.toFixed(2),
            total_pt: dedPt.toFixed(2),
            total_tds_deduction: dedTds.toFixed(2),
            total_deduction: totalDeduction.toFixed(2),
            net_salary: netSalary.toFixed(2)
        };
    };

    // Recalculate when any salary-related field changes
    useEffect(() => {
        if (formData.basic_salary || formData.da_per || formData.hra_per || formData.tds_per ||
            formData.formula || formData.pf_formula || formData.pf_epf_formula ||
            formData.esi_formula || formData.esi_formula_2 || formData.total_salary_formula ||
            formData.pf_employee_formula || formData.pf_employee_formula_2 ||
            formData.esi_employee_formula || formData.esi_employee_formula_2 ||
            formData.pt_formula || formData.tds_deduction_formula) {
            const results = calculateAll(formData);
            setFormData(prev => ({
                ...prev,
                gross_salary: results.gross_salary,
                total_pf: results.total_pf,
                total_pf_epf: results.total_pf_epf,
                total_esi: results.total_esi,
                total_esi_2: results.total_esi_2,
                total_salary: results.total_salary,
                per_day_salary: results.per_day_salary,
                total_pf_employee: results.total_pf_employee,
                total_pf_employee_2: results.total_pf_employee_2,
                total_esi_employee: results.total_esi_employee,
                total_esi_employee_2: results.total_esi_employee_2,
                total_pt: results.total_pt,
                total_tds_deduction: results.total_tds_deduction,
                total_deduction: results.total_deduction,
                net_salary: results.net_salary,
                pf_enabled: !!(formData.pf_formula || formData.pf_epf_formula),
                esi_enabled: !!(formData.esi_formula || formData.esi_formula_2 || formData.esi_employee_formula),
                pt_enabled: !!formData.pt_formula
            }));
        }
    }, [formData.basic_salary, formData.da_per, formData.hra_per, formData.tds_per,
        formData.formula, formData.pf_formula, formData.pf_epf_formula,
        formData.esi_formula, formData.esi_formula_2, formData.total_salary_formula,
        formData.pf_employee_formula, formData.pf_employee_formula_2,
        formData.esi_employee_formula, formData.esi_employee_formula_2,
        formData.pt_formula, formData.tds_deduction_formula,
        formData.working_days]);

    useEffect(() => {
        fetchUsers();
        fetchEmpTypes();
        fetchTemplates();
        if (isEditMode) {
            fetchSalaryMaster();
        }
    }, [id]);

    const fetchTemplates = async () => {
        try {
            const response = await http.get(`/salary_masters?login_user=${user.id}`);
            if (response.data.success) {
                setTemplateList(response.data.data || []);
            }
        } catch (error) {
            console.error('Error fetching templates:', error);
        }
    };

    const applyTemplate = (template) => {
        setFormData(prev => ({
            ...prev,
            basic_salary: template.basic_salary || '',
            gross_salary: template.gross_salary || '',
            per_day_salary: template.per_day_salary || '',
            da_per: template.da_per || '',
            hra_per: template.hra_per || '',
            tds_per: template.tds_per || '',
            formula: template.formula || prev.formula,
            working_days: template.working_days || prev.working_days,
            per_day_base: template.per_day_base || prev.per_day_base,
            pf_enabled: template.pf_enabled || false,
            pf_percent: template.pf_percent || '',
            esi_enabled: template.esi_enabled || false,
            esi_percent: template.esi_percent || '',
            pt_enabled: template.pt_enabled || false,
            pt_percent: template.pt_percent || '',
            pf_formula: template.pf_formula || '',
            pf_epf_formula: template.pf_epf_formula || '',
            esi_formula: template.esi_formula || '',
            esi_formula_2: template.esi_formula_2 || '',
            esi_employee_formula: template.esi_employee_formula || '',
            esi_employee_formula_2: template.esi_employee_formula_2 || '',
            pt_formula: template.pt_formula || '',
            total_salary_formula: template.total_salary_formula || '',
            pf_employee_formula: template.pf_employee_formula || '',
            pf_employee_formula_2: template.pf_employee_formula_2 || '',
            tds_deduction_formula: template.tds_deduction_formula || '',
            total_pf: template.total_pf || '',
            total_pf_epf: template.total_pf_epf || '',
            total_esi: template.total_esi || '',
            total_esi_2: template.total_esi_2 || '',
            total_esi_employee: template.total_esi_employee || '',
            total_esi_employee_2: template.total_esi_employee_2 || '',
            total_pt: template.total_pt || '',
            total_pf_employee: template.total_pf_employee || '',
            total_pf_employee_2: template.total_pf_employee_2 || '',
            total_tds_deduction: template.total_tds_deduction || '',
            total_salary: template.total_salary || '',
            total_deduction: template.total_deduction || '',
            net_salary: template.net_salary || '',
            emp_type: template.emp_type || prev.emp_type,
            grade: template.grade || prev.grade,
        }));
        setShowTemplateModal(false);
        toast.success(`Template loaded from "${template.user?.name || 'Employee'}"'s record`);
    };

    const fetchUsers = async () => {
        try {
            const response = await http.get(`/department_user_company?login_user=${user.id}`);
            if (response.data.users) {
                setUsers(response.data.users);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const fetchEmpTypes = async () => {
        try {
            const response = await http.get(`/emp_types?login_user=${user.id}`);
            if (response.data.success) {
                setEmpTypeOptions(response.data.data.map(et => ({ value: et.name, label: et.name })));
            }
        } catch (error) {
            console.error('Error fetching employee types:', error);
        }
    };

    const fetchSalaryMaster = async () => {
        try {
            const response = await http.get(`/salary_master/${id}`);
            if (response.data.success) {
                const data = response.data.data;
                setFormData({
                    user_id: data.user_id || '',
                    father_name: data.father_name || '',
                    address: data.address || '',
                    dob: data.dob ? data.dob.split('T')[0] : '',
                    date_of_join: data.date_of_join ? data.date_of_join.split('T')[0] : '',
                    designation: data.designation || '',
                    qualification: data.qualification || '',
                    experience: data.experience || '',
                    location: data.location || '',
                    bank_ifsc: data.bank_ifsc || '',
                    account_num: data.account_num || '',
                    pf_acc_num: data.pf_acc_num || '',
                    esi_number: data.esi_number || '',
                    pf_enabled: data.pf_enabled || false,
                    pf_percent: data.pf_percent || '',
                    pf_formula: data.pf_formula || '',
                    pf_epf_formula: data.pf_epf_formula || '',
                    esi_enabled: data.esi_enabled || false,
                    esi_percent: data.esi_percent || '',
                    esi_formula: data.esi_formula || '',
                    esi_formula_2: data.esi_formula_2 || '',
                    esi_employee_formula: data.esi_employee_formula || '',
                    esi_employee_formula_2: data.esi_employee_formula_2 || '',
                    pt_enabled: data.pt_enabled || false,
                    pt_percent: data.pt_percent || '',
                    pt_formula: data.pt_formula || '',
                    total_pf: data.total_pf || '',
                    total_pf_epf: data.total_pf_epf || '',
                    total_esi: data.total_esi || '',
                    total_esi_2: data.total_esi_2 || '',
                    total_esi_employee: data.total_esi_employee || '',
                    total_esi_employee_2: data.total_esi_employee_2 || '',
                    total_pt: data.total_pt || '',
                    total_salary: data.total_salary || '',
                    total_salary_formula: data.total_salary_formula || '',
                    pf_employee_formula: data.pf_employee_formula || '',
                    pf_employee_formula_2: data.pf_employee_formula_2 || '',
                    total_pf_employee: data.total_pf_employee || '',
                    total_pf_employee_2: data.total_pf_employee_2 || '',
                    tds_deduction_formula: data.tds_deduction_formula || '',
                    total_tds_deduction: data.total_tds_deduction || '',
                    total_deduction: data.total_deduction || '',
                    net_salary: data.net_salary || '',
                    emp_type: data.emp_type || '',
                    grade: data.grade || '',
                    basic_salary: data.basic_salary || '',
                    gross_salary: data.gross_salary || '',
                    per_day_salary: data.per_day_salary || '',
                    old_salary: data.old_salary || '',
                    da_per: data.da_per || '',
                    hra_per: data.hra_per || '',
                    tds_per: data.tds_per || '',
                    formula: data.formula || 'A+B+C-D',
                    working_days: data.working_days || '30',
                    per_day_base: data.per_day_base || 'E'
                });
            }
        } catch (error) {
            console.error('Error fetching salary master:', error);
            toast.error('Error fetching record');
        }
    };

    const fetchDepartments = async () => {
        try {
            const response = await http.get(`/departments?login_user=${user.id}`);
            const depts = response.data.data || [];
            const validDepts = depts.filter(d => d && d.id && d.name);
            if (validDepts.length > 0) {
                setDepartments(validDepts);
                setNoDepartments(false);
            } else {
                setDepartments([]);
                setNoDepartments(true);
            }
        } catch {
            setDepartments([]);
            setNoDepartments(true);
        }
    };

    const handleOpenEmployeeModal = () => {
        setNewEmployee({ name: '', last_name: '', email: '', password: '', department_id: '', phone_number: '', designation_name: '' });
        fetchDepartments();
        setShowEmployeeModal(true);
    };

    const handleNewEmployeeChange = (e) => {
        const { name, value } = e.target;
        setNewEmployee(prev => ({ ...prev, [name]: value }));
    };

    const handleRegisterEmployee = async (e) => {
        e.preventDefault();
        if (!newEmployee.name || !newEmployee.email || !newEmployee.password || !newEmployee.department_id || !newEmployee.phone_number) {
            toast.error('Please fill all required fields');
            return;
        }
        if (newEmployee.phone_number.length < 7 || newEmployee.phone_number.length > 10) {
            toast.error('Phone number must be 7-10 digits');
            return;
        }
        setEmpModalLoading(true);
        try {
            const response = await http.post('/register_direct_employee', {
                ...newEmployee,
                login_user: user.id
            });
            if (response.data.success) {
                toast.success('Employee registered successfully!');
                setShowEmployeeModal(false);
                await fetchUsers();
                if (response.data.user) {
                    setFormData(prev => ({ ...prev, user_id: response.data.user.id }));
                }
            } else {
                toast.error(response.data.message || 'Registration failed');
            }
        } catch (error) {
            if (error.response?.data?.errors) {
                const firstError = Object.values(error.response.data.errors)[0];
                toast.error(Array.isArray(firstError) ? firstError[0] : firstError);
            } else if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Error registering employee');
            }
        } finally {
            setEmpModalLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleUserChange = (selectedOption) => {
        setFormData({ ...formData, user_id: selectedOption ? selectedOption.value : '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.user_id) {
            toast.error('Please select an employee');
            return;
        }
        if (!formData.emp_type) {
            toast.error('Please select an Employee Type');
            return;
        }
        setLoading(true);
        try {
            const requestData = { ...formData, login_user: user.id };
            let response;
            if (isEditMode) {
                response = await http.put(`/salary_master/${id}`, requestData);
            } else {
                response = await http.post('/salary_master', requestData);
            }
            if (response.data.success) {
                toast.success(isEditMode ? 'Updated successfully!' : 'Created successfully!');
                setTimeout(() => navigate('/salary_master_list'), 1000);
            } else {
                toast.error(response.data.message || 'Failed to save');
            }
        } catch (error) {
            console.error('Error saving:', error);
            toast.error(error.response?.data?.message || 'Error saving record');
        } finally {
            setLoading(false);
        }
    };

    const userOptions = users.map(u => ({
        value: u.id,
        label: u.name + (u.last_name ? ' ' + u.last_name : '') + (u.email ? ` (${u.email})` : '')
    }));

    const gradeOptions = [
        { value: 'A', label: 'Grade A' },
        { value: 'B', label: 'Grade B' },
        { value: 'C', label: 'Grade C' },
        { value: 'D', label: 'Grade D' }
    ];

    const workingDuration = useMemo(() => {
        if (!formData.date_of_join) return null;
        const joinDate = moment(formData.date_of_join);
        const today = moment();
        if (!joinDate.isValid() || joinDate.isAfter(today)) return null;
        const years = today.diff(joinDate, 'years');
        const tempDate = moment(joinDate).add(years, 'years');
        const months = today.diff(tempDate, 'months');
        tempDate.add(months, 'months');
        const days = today.diff(tempDate, 'days');
        let parts = [];
        if (years > 0) parts.push(`${years} year${years > 1 ? 's' : ''}`);
        if (months > 0) parts.push(`${months} month${months > 1 ? 's' : ''}`);
        if (days > 0 || parts.length === 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`);
        return { text: parts.join(', '), totalDays: moment().diff(joinDate, 'days') };
    }, [formData.date_of_join]);

    // Computed intermediate values for display (DA, HRA, TDS amounts)
    const computed = useMemo(() => {
        const A = parseFloat(formData.basic_salary) || 0;
        const B = (A * (parseFloat(formData.da_per) || 0)) / 100;
        const C = (A * (parseFloat(formData.hra_per) || 0)) / 100;
        const D = (A * (parseFloat(formData.tds_per) || 0)) / 100;
        return { A, B, C, D };
    }, [formData.basic_salary, formData.da_per, formData.hra_per, formData.tds_per]);

    const fmt = (val) => {
        const num = parseFloat(val);
        if (isNaN(num)) return '0.00';
        return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const selectedUser = users.find(u => u.id === formData.user_id);

    const handlePrint = () => {
        const empName = selectedUser ? (selectedUser.name + (selectedUser.last_name ? ' ' + selectedUser.last_name : '')) : '—';
        const empEmail = selectedUser?.email || '—';
        const empPhone = selectedUser?.phone_number || '—';

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
        <html>
        <head>
            <title>Salary Master - ${empName}</title>
            <style>
                * { margin: 0; padding: 0; box-sizing: border-box; }
                body { font-family: 'Segoe UI', Arial, sans-serif; padding: 30px; color: #333; font-size: 13px; }
                .header { text-align: center; margin-bottom: 20px; border-bottom: 2px solid #333; padding-bottom: 10px; }
                .header h2 { font-size: 18px; margin-bottom: 2px; }
                .header p { font-size: 11px; color: #666; }
                .info-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 6px 20px; margin-bottom: 18px; padding: 10px; background: #f8f9fa; border-radius: 6px; }
                .info-item { display: flex; gap: 6px; }
                .info-label { font-weight: 700; white-space: nowrap; min-width: 100px; }
                .info-value { color: #555; }
                table { width: 100%; border-collapse: collapse; margin-bottom: 16px; }
                th, td { border: 1px solid #ccc; padding: 5px 8px; font-size: 12px; }
                th { background: #e9ecef; font-weight: 700; text-align: center; }
                .section-head td { background: #dee2e6; font-weight: 700; font-size: 12px; }
                .section-head-ded td { background: #f8d7da; font-weight: 700; font-size: 12px; }
                .gross-row td { background: #fff3cd; font-weight: 600; }
                .employer-row td { background: #f3e8ff; }
                .total-salary-row td { background: #d4edda; font-weight: 700; font-size: 13px; }
                .perday-row td { background: #d1ecf1; }
                .deduction-row td { background: #fff9c4; }
                .total-ded-row td { background: #ffe082; font-weight: 600; }
                .net-row td { background: #00897b; color: #fff; font-weight: 700; font-size: 14px; }
                .text-right { text-align: right; font-family: 'Courier New', monospace; }
                .text-center { text-align: center; }
                .signature-section { margin-top: 40px; display: flex; justify-content: space-between; }
                .sig-box { text-align: center; width: 200px; }
                .sig-line { border-top: 1px solid #333; margin-top: 50px; padding-top: 5px; font-size: 12px; }
                .print-date { text-align: right; font-size: 11px; color: #888; margin-bottom: 10px; }
                @media print { body { padding: 15px; } }
            </style>
        </head>
        <body>
            <div class="print-date">Printed on: ${moment().format('DD/MM/YYYY hh:mm A')}</div>
            <div class="header">
                <h2>SALARY MASTER</h2>
                <p>Employee Salary Structure Document</p>
            </div>

            <div class="info-grid">
                <div class="info-item"><span class="info-label">Name:</span><span class="info-value">${empName}</span></div>
                <div class="info-item"><span class="info-label">Email:</span><span class="info-value">${empEmail}</span></div>
                <div class="info-item"><span class="info-label">Phone:</span><span class="info-value">${empPhone}</span></div>
                <div class="info-item"><span class="info-label">Designation:</span><span class="info-value">${formData.designation || '—'}</span></div>
                <div class="info-item"><span class="info-label">Emp Type:</span><span class="info-value">${formData.emp_type || '—'}</span></div>
                <div class="info-item"><span class="info-label">Grade:</span><span class="info-value">${formData.grade || '—'}</span></div>
                <div class="info-item"><span class="info-label">Father Name:</span><span class="info-value">${formData.father_name || '—'}</span></div>
                <div class="info-item"><span class="info-label">DOB:</span><span class="info-value">${formData.dob ? moment(formData.dob).format('DD/MM/YYYY') : '—'}</span></div>
                <div class="info-item"><span class="info-label">Date of Join:</span><span class="info-value">${formData.date_of_join ? moment(formData.date_of_join).format('DD/MM/YYYY') : '—'}</span></div>
                <div class="info-item"><span class="info-label">Qualification:</span><span class="info-value">${formData.qualification || '—'}</span></div>
                <div class="info-item"><span class="info-label">Experience:</span><span class="info-value">${formData.experience || '—'}</span></div>
                <div class="info-item"><span class="info-label">Location:</span><span class="info-value">${formData.location || '—'}</span></div>
            </div>

            <table>
                <thead><tr><th style="width:40px">Sl</th><th>Component</th><th style="width:160px">Formula / %</th><th style="width:130px">Amount (₹)</th></tr></thead>
                <tbody>
                    <tr class="section-head"><td colspan="4">Gross Salary</td></tr>
                    <tr><td class="text-center">1</td><td>Basic Salary (A)</td><td class="text-center">Fixed</td><td class="text-right">${fmt(formData.basic_salary)}</td></tr>
                    <tr><td class="text-center">2</td><td>Dearness Allowance - DA (B)</td><td class="text-center">A × ${formData.da_per || 0}%</td><td class="text-right">${fmt(computed.B)}</td></tr>
                    <tr><td class="text-center">3</td><td>House Rent Allowance - HRA (C)</td><td class="text-center">A × ${formData.hra_per || 0}%</td><td class="text-right">${fmt(computed.C)}</td></tr>
                    <tr><td class="text-center">4</td><td>TDS (D)</td><td class="text-center">${formData.tds_per || 0}%</td><td class="text-right">${fmt(computed.D)}</td></tr>
                    <tr class="gross-row"><td class="text-center">5</td><td><strong>Gross Salary (E)</strong></td><td class="text-center">${formData.formula || 'A+B+C-D'}</td><td class="text-right"><strong>${fmt(formData.gross_salary)}</strong></td></tr>

                    <tr><td colspan="4" style="padding:3px;background:#f8f9fa"></td></tr>
                    <tr class="employer-row"><td class="text-center">7</td><td>PF Contribution - EPS Employer (F)</td><td class="text-center">${formData.pf_formula || '—'}</td><td class="text-right">${fmt(formData.total_pf)}</td></tr>
                    <tr class="employer-row"><td class="text-center">7</td><td>PF Contribution - EPF Employer (G)</td><td class="text-center">${formData.pf_epf_formula || '—'}</td><td class="text-right">${fmt(formData.total_pf_epf)}</td></tr>
                    <tr class="employer-row"><td class="text-center">8</td><td>ESI Contribution Employer (H)</td><td class="text-center">${formData.esi_formula || '—'}</td><td class="text-right">${fmt(formData.total_esi)}</td></tr>
                    <tr class="employer-row"><td class="text-center">9</td><td>ESI Contribution Employer-2 (K)</td><td class="text-center">${formData.esi_formula_2 || '—'}</td><td class="text-right">${fmt(formData.total_esi_2)}</td></tr>

                    <tr><td colspan="4" style="padding:3px;background:#f8f9fa"></td></tr>
                    <tr class="total-salary-row"><td></td><td><strong>TOTAL SALARY (I)</strong></td><td class="text-center">${formData.total_salary_formula || '—'}</td><td class="text-right"><strong>${fmt(formData.total_salary)}</strong></td></tr>
                    <tr class="perday-row"><td class="text-center">6</td><td>Per Day Salary (J)</td><td class="text-center">${formData.per_day_base || 'E'} ÷ ${formData.working_days || 30}</td><td class="text-right">${fmt(formData.per_day_salary)}</td></tr>

                    <tr><td colspan="4" style="padding:4px;background:#f8f9fa"></td></tr>
                    <tr class="section-head-ded"><td colspan="2">DEDUCTIONS</td><td>Formula</td><td>Amount (₹)</td></tr>
                    <tr class="deduction-row"><td class="text-center">10</td><td>PF Contribution (Employee)</td><td class="text-center">${formData.pf_employee_formula || '—'}</td><td class="text-right">${fmt(formData.total_pf_employee)}</td></tr>
                    <tr class="deduction-row"><td class="text-center">11</td><td>PF Contribution (Employee)-2</td><td class="text-center">${formData.pf_employee_formula_2 || '—'}</td><td class="text-right">${fmt(formData.total_pf_employee_2)}</td></tr>
                    <tr class="deduction-row"><td class="text-center">12</td><td>ESI Contribution (Employee)</td><td class="text-center">${formData.esi_employee_formula || '—'}</td><td class="text-right">${fmt(formData.total_esi_employee)}</td></tr>
                    <tr class="deduction-row"><td class="text-center">13</td><td>ESI Contribution (Employee)-2</td><td class="text-center">${formData.esi_employee_formula_2 || '—'}</td><td class="text-right">${fmt(formData.total_esi_employee_2)}</td></tr>
                    <tr class="deduction-row"><td class="text-center">14</td><td>Professional Tax</td><td class="text-center">${formData.pt_formula || '—'}</td><td class="text-right">${fmt(formData.total_pt)}</td></tr>
                    <tr class="deduction-row"><td class="text-center">15</td><td>Tax Deduction at Source</td><td class="text-center">${formData.tds_deduction_formula || '—'}</td><td class="text-right">${fmt(formData.total_tds_deduction)}</td></tr>
                    <tr class="total-ded-row"><td></td><td colspan="2" style="text-align:right"><strong>Total Deduction</strong></td><td class="text-right"><strong>${fmt(formData.total_deduction)}</strong></td></tr>
                    <tr class="net-row"><td class="text-center">16</td><td><strong>NET SALARY (Take Home)</strong></td><td class="text-center">I − Total Deduction</td><td class="text-right"><strong>${fmt(formData.net_salary)}</strong></td></tr>
                </tbody>
            </table>

            <div class="info-grid" style="grid-template-columns:1fr 1fr;">
                <div class="info-item"><span class="info-label">Bank IFSC:</span><span class="info-value">${formData.bank_ifsc || '—'}</span></div>
                <div class="info-item"><span class="info-label">Account No:</span><span class="info-value">${formData.account_num || '—'}</span></div>
                <div class="info-item"><span class="info-label">PF Account:</span><span class="info-value">${formData.pf_acc_num || '—'}</span></div>
                <div class="info-item"><span class="info-label">ESI Number:</span><span class="info-value">${formData.esi_number || '—'}</span></div>
            </div>

            <div class="signature-section">
                <div class="sig-box"><div class="sig-line">Employee Signature</div></div>
                <div class="sig-box"><div class="sig-line">HR / Manager</div></div>
                <div class="sig-box"><div class="sig-line">Approved By</div></div>
            </div>
        </body>
        </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => { printWindow.print(); }, 300);
    };

    const sectionCardStyle = {
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        marginBottom: '20px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
    };

    const sectionHeaderStyle = {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '10px 15px',
        borderRadius: '7px 7px 0 0',
        fontSize: '14px',
        fontWeight: '600'
    };

    return (
        <>
            <Toaster />
            <style>{salaryTableStyles}</style>
            <div className="container-fluid mt-2 px-3">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <h5 className="mb-0">{isEditMode ? 'Edit' : 'Add'} Employee Salary Master</h5>
                        <small className="text-muted">Manage employee salary and personal information</small>
                    </div>
                    <div className="d-flex gap-2">
                        {isEditMode && (
                            <button type="button" className="btn btn-outline-primary btn-sm" onClick={handlePrint}>
                                <i className="fa fa-print me-1"></i> Print
                            </button>
                        )}
                        <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate('/salary_master_list')}>
                            <i className="fa fa-arrow-left me-1"></i> Back to List
                        </button>
                    </div>
                </div>
                
                <form onSubmit={handleSubmit}>
                    {/* ===== SECTION 1: Personal Details ===== */}
                    <div style={sectionCardStyle}>
                        <div style={sectionHeaderStyle}>
                            <i className="fa fa-user me-2"></i>Personal Details
                        </div>
                        <div className="p-3">
                            <div className="row g-3">
                                <div className="col-md-4">
                                    <label className="form-label fw-semibold">Employee <span className="text-danger">*</span></label>
                                    <div className="d-flex gap-2">
                                        <div style={{flex: 1}}>
                                            <Select
                                                options={userOptions}
                                                onChange={handleUserChange}
                                                value={userOptions.find(opt => opt.value === formData.user_id) || null}
                                                isSearchable={true}
                                                placeholder="Search and select employee..."
                                                isClearable={true}
                                                isDisabled={isEditMode}
                                                styles={{ menu: (base) => ({ ...base, zIndex: 9999 }), control: (base) => ({ ...base, borderColor: '#ced4da' }) }}
                                            />
                                        </div>
                                        {!isEditMode && (
                                            <button type="button" className="btn btn-success btn-sm" onClick={handleOpenEmployeeModal} title="Add Direct Employee" style={{whiteSpace: 'nowrap'}}>
                                                <i className="fa fa-user-plus me-1"></i> Add Employee
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">Designation</label>
                                    <input type="text" className="form-control" name="designation" value={formData.designation} onChange={handleChange} placeholder="e.g., Software Engineer" />
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">Father's Name</label>
                                    <input type="text" className="form-control" name="father_name" value={formData.father_name} onChange={handleChange} placeholder="Enter father's name" />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Date of Birth</label>
                                    <input type="date" className="form-control" name="dob" value={formData.dob} onChange={handleChange} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Date of Joining</label>
                                    <input type="date" className="form-control" name="date_of_join" value={formData.date_of_join} onChange={handleChange} />
                                    {workingDuration && (
                                        <small className="text-success d-block mt-1">
                                            <i className="fa fa-clock me-1"></i>
                                            <strong>{workingDuration.text}</strong>
                                            <span className="text-muted ms-1">({workingDuration.totalDays} days)</span>
                                        </small>
                                    )}
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Qualification</label>
                                    <input type="text" className="form-control" name="qualification" value={formData.qualification} onChange={handleChange} placeholder="e.g., B.Tech, MBA" />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Experience</label>
                                    <input type="text" className="form-control" name="experience" value={formData.experience} onChange={handleChange} placeholder="e.g., 5 years" />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Location</label>
                                    <input type="text" className="form-control" name="location" value={formData.location} onChange={handleChange} placeholder="Work location" />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Employee Type <span style={{ color: 'red' }}>*</span></label>
                                    <Select options={empTypeOptions} onChange={(opt) => setFormData({...formData, emp_type: opt ? opt.value : ''})} value={empTypeOptions.find(opt => opt.value === formData.emp_type) || null} placeholder="Select type" isClearable={true} styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Grade</label>
                                    <Select options={gradeOptions} onChange={(opt) => setFormData({...formData, grade: opt ? opt.value : ''})} value={gradeOptions.find(opt => opt.value === formData.grade) || null} placeholder="Select grade" isClearable={true} styles={{ menu: (base) => ({ ...base, zIndex: 9999 }) }} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted">Old Salary</label>
                                    <div className="input-group">
                                        <span className="input-group-text">₹</span>
                                        <input type="number" className="form-control" name="old_salary" value={formData.old_salary} onChange={handleChange} placeholder="Previous salary" step="0.01" />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label className="form-label">Address</label>
                                    <textarea className="form-control" name="address" value={formData.address} onChange={handleChange} placeholder="Enter full address" rows="2" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ===== SECTION 2: Salary Component Wise Table ===== */}
                    <div style={sectionCardStyle}>
                        <div style={{...sectionHeaderStyle, background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <span><i className="fa fa-money-bill-wave me-2"></i>Salary Master - Component Wise Table</span>
                            {templateList.length > 0 && (
                                <button type="button" className="btn btn-sm btn-light" style={{ fontWeight: 600, fontSize: '12px', borderRadius: '20px', padding: '3px 14px' }} onClick={() => setShowTemplateModal(true)}>
                                    <i className="fa fa-magic me-1"></i>Load Template
                                </button>
                            )}
                        </div>
                        <div className="p-3">
                            <div className="table-responsive">
                                <table className="table salary-table mb-0">
                                    <thead>
                                        <tr>
                                            <th style={{width: '50px'}}>Sl No</th>
                                            <th style={{width: '230px'}}>Component</th>
                                            <th style={{width: '55px'}}>Variable</th>
                                            <th className="formula-col" style={{width: '220px'}}>Formula / %</th>
                                            <th style={{width: '140px'}}>Calculated Value (₹)</th>
                                            <th style={{width: '90px'}}>Method</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* ========== GROSS SALARY SECTION ========== */}
                                        <tr className="section-row">
                                            <td colSpan="6"><i className="fa fa-coins me-1"></i> Gross Salary</td>
                                        </tr>

                                        {/* 1: Basic Salary (A) */}
                                        <tr>
                                            <td className="text-center">1</td>
                                            <td><strong>Basic Salary</strong></td>
                                            <td className="text-center"><span className="var-badge" style={{background:'#198754'}}>A</span></td>
                                            <td className="text-center"><span className="formula-text">Fixed</span></td>
                                            <td className="value-cell">
                                                <input type="number" className="value-input" name="basic_salary" value={formData.basic_salary} onChange={handleChange} placeholder="0.00" step="0.01" />
                                            </td>
                                            <td className="text-center"><span className="method-badge bg-warning text-dark">Manual Entry</span></td>
                                        </tr>

                                        {/* 2: DA (B) */}
                                        <tr>
                                            <td className="text-center">2</td>
                                            <td>Dearness Allowance (DA)</td>
                                            <td className="text-center"><span className="var-badge">B</span></td>
                                            <td>
                                                <div className="pct-input-group">
                                                    <span className="formula-text">A ×</span>
                                                    <input type="number" className="pct-input" name="da_per" value={formData.da_per} onChange={handleChange} placeholder="0" step="0.01" />
                                                    <span className="formula-text">%</span>
                                                </div>
                                            </td>
                                            <td className="value-cell">{fmt(computed.B)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 3: HRA (C) */}
                                        <tr>
                                            <td className="text-center">3</td>
                                            <td>House Rent Allowance (HRA)</td>
                                            <td className="text-center"><span className="var-badge">C</span></td>
                                            <td>
                                                <div className="pct-input-group">
                                                    <span className="formula-text">A ×</span>
                                                    <input type="number" className="pct-input" name="hra_per" value={formData.hra_per} onChange={handleChange} placeholder="0" step="0.01" />
                                                    <span className="formula-text">%</span>
                                                </div>
                                            </td>
                                            <td className="value-cell">{fmt(computed.C)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 4: TDS (D) */}
                                        <tr>
                                            <td className="text-center">4</td>
                                            <td>TDS</td>
                                            <td className="text-center"><span className="var-badge" style={{background:'#dc3545'}}>D</span></td>
                                            <td>
                                                <div className="pct-input-group">
                                                    <input type="number" className="pct-input" name="tds_per" value={formData.tds_per} onChange={handleChange} placeholder="0" step="0.01" />
                                                    <span className="formula-text">%</span>
                                                </div>
                                            </td>
                                            <td className="value-cell">{fmt(computed.D)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 5: Gross Salary (E) */}
                                        <tr className="gross-row">
                                            <td className="text-center">5</td>
                                            <td><strong>Gross Salary</strong></td>
                                            <td className="text-center"><span className="var-badge" style={{background:'#fd7e14'}}>E</span></td>
                                            <td>
                                                <input type="text" className="formula-input" name="formula" value={formData.formula} onChange={handleChange} placeholder="A+B+C-D" />
                                            </td>
                                            <td className="value-cell" style={{color:'#198754',fontSize:'0.9rem'}}>
                                                <strong>{fmt(formData.gross_salary)}</strong>
                                            </td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* ========== EMPLOYER CONTRIBUTION SECTION ========== */}
                                        <tr><td colSpan="6" style={{padding:'3px',background:'#f8f9fa'}}></td></tr>

                                        {/* 7: PF EPS Employer (F) */}
                                        <tr className="employer-row">
                                            <td className="text-center">7</td>
                                            <td>PF Contribution - EPS (Employer)</td>
                                            <td className="text-center"><span className="var-badge" style={{background:'#0d6efd'}}>F</span></td>
                                            <td>
                                                <input type="text" className="formula-input" name="pf_formula" value={formData.pf_formula} onChange={handleChange} placeholder="e.g., 15000*0.08" />
                                            </td>
                                            <td className="value-cell">{fmt(formData.total_pf)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 7: PF EPF Employer (G) */}
                                        <tr className="employer-row">
                                            <td className="text-center">7</td>
                                            <td>PF Contribution - EPF (Employer)</td>
                                            <td className="text-center"><span className="var-badge" style={{background:'#0d6efd'}}>G</span></td>
                                            <td>
                                                <input type="text" className="formula-input" name="pf_epf_formula" value={formData.pf_epf_formula} onChange={handleChange} placeholder="e.g., 15000*0.04" />
                                            </td>
                                            <td className="value-cell">{fmt(formData.total_pf_epf)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 8: ESI Employer (H) */}
                                        <tr className="employer-row">
                                            <td className="text-center">8</td>
                                            <td>ESI Contribution (Employer)</td>
                                            <td className="text-center"><span className="var-badge" style={{background:'#6f42c1'}}>H</span></td>
                                            <td>
                                                <input type="text" className="formula-input" name="esi_formula" value={formData.esi_formula} onChange={handleChange} placeholder="e.g., (A+B+C)*0.0075" />
                                            </td>
                                            <td className="value-cell">{fmt(formData.total_esi)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 9: ESI Employer-2 (K) */}
                                        <tr className="employer-row">
                                            <td className="text-center">9</td>
                                            <td>ESI Contribution (Employer)-2</td>
                                            <td className="text-center"><span className="var-badge" style={{background:'#6f42c1'}}>K</span></td>
                                            <td>
                                                <input type="text" className="formula-input" name="esi_formula_2" value={formData.esi_formula_2} onChange={handleChange} placeholder="e.g., (A+B+C)*0.0325" />
                                            </td>
                                            <td className="value-cell">{fmt(formData.total_esi_2)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* ========== TOTAL SALARY & PER DAY ========== */}
                                        <tr><td colSpan="6" style={{padding:'3px',background:'#f8f9fa'}}></td></tr>

                                        {/* TOTAL SALARY (I) */}
                                        <tr className="total-salary-row">
                                            <td className="text-center"></td>
                                            <td><strong>TOTAL SALARY</strong></td>
                                            <td className="text-center"><span className="var-badge" style={{background:'#198754'}}>I</span></td>
                                            <td>
                                                <input type="text" className="formula-input" name="total_salary_formula" value={formData.total_salary_formula} onChange={handleChange} placeholder="e.g., E+F+G+H+K" style={{fontWeight:'700',background:'#f0fdf4'}} />
                                            </td>
                                            <td className="value-cell" style={{fontSize:'1rem',color:'#198754'}}>
                                                <strong>{fmt(formData.total_salary)}</strong>
                                            </td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 6: Per Day Salary (J) */}
                                        <tr className="perday-row">
                                            <td className="text-center">6</td>
                                            <td>Per Day Salary</td>
                                            <td className="text-center"><span className="var-badge" style={{background:'#0dcaf0'}}>J</span></td>
                                            <td>
                                                <div className="pct-input-group">
                                                    <select name="per_day_base" value={formData.per_day_base} onChange={handleChange} style={{border:'1px solid #ced4da', borderRadius:'4px', padding:'2px 4px', fontSize:'12px', fontWeight:700, background:'#fff'}}>
                                                        <option value="E">E</option>
                                                        <option value="I">I</option>
                                                    </select>
                                                    <span className="formula-text"> ÷ </span>
                                                    <input type="number" className="pct-input" name="working_days" value={formData.working_days} onChange={handleChange} placeholder="30" step="1" min="1" style={{width:'50px'}} />
                                                </div>
                                            </td>
                                            <td className="value-cell">{fmt(formData.per_day_salary)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* ========== DEDUCTIONS SECTION ========== */}
                                        <tr><td colSpan="6" style={{padding:'6px',background:'#f8f9fa'}}></td></tr>

                                        <tr className="section-row-deduction">
                                            <td colSpan="3"><i className="fa fa-minus-circle me-1"></i> DEDUCTIONS</td>
                                            <td><strong>Formula</strong></td>
                                            <td></td>
                                            <td></td>
                                        </tr>

                                        {/* 10: PF Contribution Employee */}
                                        <tr className="deduction-row">
                                            <td className="text-center">10</td>
                                            <td>PF Contribution (Employee)</td>
                                            <td className="text-center">—</td>
                                            <td>
                                                <input type="text" className="formula-input" name="pf_employee_formula" value={formData.pf_employee_formula} onChange={handleChange} placeholder="e.g., 15000*0.12" />
                                            </td>
                                            <td className="value-cell">{fmt(formData.total_pf_employee)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 11: PF Contribution Employee-2 */}
                                        <tr className="deduction-row">
                                            <td className="text-center">11</td>
                                            <td>PF Contribution (Employee)-2</td>
                                            <td className="text-center">—</td>
                                            <td>
                                                <input type="text" className="formula-input" name="pf_employee_formula_2" value={formData.pf_employee_formula_2} onChange={handleChange} placeholder="e.g., 15000*0.04" />
                                            </td>
                                            <td className="value-cell">{fmt(formData.total_pf_employee_2)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 12: ESI Contribution Employee */}
                                        <tr className="deduction-row">
                                            <td className="text-center">12</td>
                                            <td>ESI Contribution (Employee)</td>
                                            <td className="text-center">—</td>
                                            <td>
                                                <input type="text" className="formula-input" name="esi_employee_formula" value={formData.esi_employee_formula} onChange={handleChange} placeholder="e.g., (A+B+C)*0.0075" />
                                            </td>
                                            <td className="value-cell">{fmt(formData.total_esi_employee)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 13: ESI Contribution Employee-2 */}
                                        <tr className="deduction-row">
                                            <td className="text-center">13</td>
                                            <td>ESI Contribution (Employee)-2</td>
                                            <td className="text-center">—</td>
                                            <td>
                                                <input type="text" className="formula-input" name="esi_employee_formula_2" value={formData.esi_employee_formula_2} onChange={handleChange} placeholder="e.g., (A+B+C)*0.0325" />
                                            </td>
                                            <td className="value-cell">{fmt(formData.total_esi_employee_2)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 14: Professional Tax */}
                                        <tr className="deduction-row">
                                            <td className="text-center">14</td>
                                            <td>Professional Tax</td>
                                            <td className="text-center">—</td>
                                            <td>
                                                <input type="text" className="formula-input" name="pt_formula" value={formData.pt_formula} onChange={handleChange} placeholder="e.g., 200" />
                                            </td>
                                            <td className="value-cell">{fmt(formData.total_pt)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* 15: Tax Deduction at Source */}
                                        <tr className="deduction-row">
                                            <td className="text-center">15</td>
                                            <td>Tax Deduction at Source</td>
                                            <td className="text-center">—</td>
                                            <td>
                                                <input type="text" className="formula-input" name="tds_deduction_formula" value={formData.tds_deduction_formula} onChange={handleChange} placeholder="e.g., (A+B+C)*0.01" />
                                            </td>
                                            <td className="value-cell">{fmt(formData.total_tds_deduction)}</td>
                                            <td className="text-center"><span className="method-badge bg-info text-white">Auto</span></td>
                                        </tr>

                                        {/* Total Deduction */}
                                        <tr className="total-deduction-row">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td className="text-end"><strong>Total Deduction</strong></td>
                                            <td className="value-cell" style={{color:'#e65100'}}>
                                                <strong>{fmt(formData.total_deduction)}</strong>
                                            </td>
                                            <td></td>
                                        </tr>

                                        {/* 16: NET SALARY */}
                                        <tr className="net-salary-row">
                                            <td className="text-center">16</td>
                                            <td><strong>NET SALARY (Take Home)</strong></td>
                                            <td></td>
                                            <td className="text-center" style={{color:'#b2dfdb',fontFamily:'monospace'}}>I - Total Deduction</td>
                                            <td className="value-cell" style={{fontSize:'1.05rem',color:'#fff'}}>
                                                <strong>{fmt(formData.net_salary)}</strong>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Formula Legend */}
                            <div className="bg-light rounded p-2 mt-3">
                                <small className="text-muted">
                                    <strong>Formula Variables:</strong>{' '}
                                    <span className="badge bg-secondary">A</span> Basic{' '}
                                    <span className="badge bg-secondary">B</span> DA Amt{' '}
                                    <span className="badge bg-secondary">C</span> HRA Amt{' '}
                                    <span className="badge bg-secondary">D</span> TDS Amt{' '}
                                    <span className="badge bg-secondary">E</span> Gross{' '}
                                    <span className="badge bg-secondary">F</span> PF EPS{' '}
                                    <span className="badge bg-secondary">G</span> PF EPF{' '}
                                    <span className="badge bg-secondary">H</span> ESI Employer{' '}
                                    <span className="badge bg-secondary">K</span> ESI Employer-2{' '}
                                    <span className="badge bg-secondary">I</span> Total Salary{' '}
                                    <span className="badge bg-secondary">J</span> Per Day
                                    <br/><strong>Deduction formulas</strong> can also use A–K, I, J variables.
                                </small>
                            </div>
                        </div>
                    </div>

                    {/* ===== SECTION 3: Bank & Statutory Account Details ===== */}
                    <div style={sectionCardStyle}>
                        <div style={{...sectionHeaderStyle, background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)'}}>
                            <i className="fa fa-university me-2"></i>Bank & Statutory Account Details
                        </div>
                        <div className="p-3">
                            <div className="row g-3">
                                <div className="col-md-3">
                                    <label className="form-label">Bank IFSC Code</label>
                                    <input type="text" className="form-control" name="bank_ifsc" value={formData.bank_ifsc} onChange={handleChange} placeholder="e.g., SBIN0001234" />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Account Number</label>
                                    <input type="text" className="form-control" name="account_num" value={formData.account_num} onChange={handleChange} placeholder="Bank account number" />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">PF Account Number</label>
                                    <input type="text" className="form-control" name="pf_acc_num" value={formData.pf_acc_num} onChange={handleChange} placeholder="PF account number" />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">ESI Number</label>
                                    <input type="text" className="form-control" name="esi_number" value={formData.esi_number} onChange={handleChange} placeholder="ESI number" />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="card mt-2 mb-4">
                        <div className="card-body py-3">
                            <div className="d-flex justify-content-end gap-2">
                                <button type="button" className="btn btn-outline-secondary px-4" onClick={() => navigate('/salary_master_list')}>
                                    <i className="fa fa-times me-1"></i> Cancel
                                </button>
                                <button type="submit" className="btn btn-primary px-4" disabled={loading}>
                                    {loading ? (
                                        <><span className="spinner-border spinner-border-sm me-1"></span>Saving...</>
                                    ) : (
                                        <><i className="fa fa-save me-1"></i>{isEditMode ? 'Update Record' : 'Save Record'}</>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            {/* Add Direct Employee Modal */}
            {showEmployeeModal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header" style={{background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white'}}>
                                <h5 className="modal-title"><i className="fa fa-user-plus me-2"></i>Add Direct Employee</h5>
                                <button type="button" className="btn-close btn-close-white" onClick={() => setShowEmployeeModal(false)}></button>
                            </div>
                            <form onSubmit={handleRegisterEmployee}>
                                <div className="modal-body">
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">First Name <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control text-uppercase" name="name" value={newEmployee.name} onChange={handleNewEmployeeChange} placeholder="Enter first name" required />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Last Name <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control text-uppercase" name="last_name" value={newEmployee.last_name} onChange={handleNewEmployeeChange} placeholder="Enter last name" required />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Department <span className="text-danger">*</span></label>
                                            <select className="form-control text-uppercase" name="department_id" value={newEmployee.department_id} onChange={handleNewEmployeeChange} required>
                                                <option value="">SELECT DEPARTMENT</option>
                                                {!noDepartments && departments.length > 0 ? (
                                                    departments.map(dept => (
                                                        <option key={dept.id} value={dept.id}>{dept.name}</option>
                                                    ))
                                                ) : (
                                                    [
                                                        <option key="1" value="1">Super Admin</option>,
                                                        <option key="3" value="3">Sub Admin</option>,
                                                        <option key="2" value="2">Team Member</option>,
                                                        <option key="4" value="4">Consultant</option>,
                                                        <option key="5" value="5">Co-Admin</option>
                                                    ]
                                                )}
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Phone Number <span className="text-danger">*</span></label>
                                            <input type="number" className="form-control" name="phone_number" value={newEmployee.phone_number} onChange={handleNewEmployeeChange} placeholder="Enter phone number" required />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Email Address <span className="text-danger">*</span></label>
                                            <input type="email" className="form-control" name="email" value={newEmployee.email} onChange={handleNewEmployeeChange} placeholder="Enter email address" required />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Password <span className="text-danger">*</span></label>
                                            <input type="password" className="form-control" name="password" value={newEmployee.password} onChange={handleNewEmployeeChange} placeholder="Enter password" required />
                                        </div>
                                    </div>
                                    <div className="alert alert-info mt-3 mb-0 py-2" style={{fontSize: '0.85rem'}}>
                                        <i className="fa fa-info-circle me-1"></i>
                                        The employee will be auto-approved and assigned to your company. They can log in immediately after registration.
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-outline-secondary" onClick={() => setShowEmployeeModal(false)}>
                                        <i className="fa fa-times me-1"></i> Cancel
                                    </button>
                                    <button type="submit" className="btn btn-success" disabled={empModalLoading}>
                                        {empModalLoading ? (
                                            <><span className="spinner-border spinner-border-sm me-1"></span>Registering...</>
                                        ) : (
                                            <><i className="fa fa-user-plus me-1"></i> Register Employee</>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Load Template Modal */}
            {showTemplateModal && (
                <div className="modal" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content" style={{ borderRadius: '10px', border: 'none' }}>
                            <div className="modal-header py-2" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#fff' }}>
                                <h6 className="modal-title mb-0"><i className="fa fa-magic me-2"></i>Load Template from Existing Record</h6>
                                <button type="button" className="btn-close btn-close-white" onClick={() => setShowTemplateModal(false)}></button>
                            </div>
                            <div className="modal-body p-0">
                                <div className="p-3 bg-light border-bottom" style={{ fontSize: '12px', color: '#666' }}>
                                    <i className="fa fa-info-circle me-1"></i>
                                    Select an employee record to copy all formulas, percentages & deduction settings. Personal details will not be copied.
                                </div>
                                <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    <table className="table table-hover table-sm mb-0" style={{ fontSize: '13px' }}>
                                        <thead className="table-light sticky-top">
                                            <tr>
                                                <th style={{ width: '30%' }}>Employee</th>
                                                <th style={{ width: '15%' }}>Type</th>
                                                <th style={{ width: '12%' }}>Basic</th>
                                                <th style={{ width: '10%' }}>DA%</th>
                                                <th style={{ width: '10%' }}>HRA%</th>
                                                <th style={{ width: '10%' }}>PF</th>
                                                <th style={{ width: '13%' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {templateList.map(t => (
                                                <tr key={t.id}>
                                                    <td>
                                                        <strong>{t.user?.name || '-'} {t.user?.last_name || ''}</strong>
                                                        <br /><small className="text-muted">{t.designation || '-'}</small>
                                                    </td>
                                                    <td>{t.emp_type || '-'}</td>
                                                    <td>{t.basic_salary ? parseFloat(t.basic_salary).toLocaleString('en-IN') : '-'}</td>
                                                    <td>{t.da_per || '0'}%</td>
                                                    <td>{t.hra_per || '0'}%</td>
                                                    <td><span style={{ color: t.pf_formula ? '#2e7d32' : '#999' }}>{t.pf_formula ? 'Yes' : 'No'}</span></td>
                                                    <td className="text-end">
                                                        <button type="button" className="btn btn-sm btn-outline-primary" style={{ borderRadius: '15px', fontSize: '11px', padding: '2px 12px' }} onClick={() => applyTemplate(t)}>
                                                            <i className="fa fa-copy me-1"></i>Use
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {templateList.length === 0 && (
                                                <tr><td colSpan="7" className="text-center text-muted py-3">No existing salary masters found</td></tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer py-2">
                                <button type="button" className="btn btn-sm btn-secondary" onClick={() => setShowTemplateModal(false)}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
